import glamorous from "glamorous"
const TextInput = glamorous.input({
  lineHeight: "23px",
  width: "100%",
  padding: "8px 20px",
  fontSize: "18px",
  border: "solid 2px grey",
  color: "#333",
  paddingRight: "40px",
  fontFamily: "JWSansBook"
});

export default TextInput;



// WEBPACK FOOTER //
// ./src/components/common/TextInput.js